import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  dialogSubTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: 0,
  },
})

export { useStyles }
